import DiscussSpeech from './src/main';

/* istanbul ignore next */
DiscussSpeech.install = function(Vue) {
  Vue.component(DiscussSpeech.name, DiscussSpeech);
};

export default DiscussSpeech;
